import { render } from "./TvmFlowEndLink.vue?vue&type=template&id=6283137e&scoped=true"
import script from "./TvmFlowEndLink.vue?vue&type=script&lang=js"
export * from "./TvmFlowEndLink.vue?vue&type=script&lang=js"

import "./TvmFlowEndLink.vue?vue&type=style&index=0&id=6283137e&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6283137e"]])

export default __exports__